<template>
  <v-alert
    v-if="getConfig('REFINERY_BANNER_ENABLED')"
    type="info"
    border="left"
    colored-border
    class="mb-4"
    prominent
    dense
  >
    <v-row align="center" no-gutters>
      <v-col>
        <div class="font-weight-medium">{{ getConfig('REFINERY_BANNER_MESSAGE') }}</div>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RefineryBanner',
  data() {
    return {
      online: true,
      bannerInterval: null,
    }
  },
  methods: {
    bannerUpdater() {
      if (this.online) {
        return this.$store.dispatch('fetchConfig').finally(() => {
          this.bannerInterval = setTimeout(() => {
            this.bannerUpdater()
          }, 5000)
        })
      }
    },
  },
  computed: {
    ...mapGetters(['getConfig']),
  },
  created() {
    window._VMA.$on('AUTH_FAILED', () => {
      clearInterval(this.bannerInterval)
      this.online = false
    })
    window._VMA.$on('LOGOUT', () => {
      clearInterval(this.bannerInterval)
      this.online = false
    })
  },
  beforeDestroy() {
    clearTimeout(this.bannerInterval)
  },
  async mounted() {
    await this.$store.dispatch('fetchConfig')
    this.bannerUpdater()
  },
}
</script>
